import classNames from "classnames";
import { Col } from "react-bootstrap";
import { prepositions } from "../../../../libs/prepositons";
import HtmlParser from "components/utilities/HTMLParser";
import { HTMLColProps } from "../../../../types/htmlElementTypes";
import classes from "./IconAndTextItem.module.scss";

export interface IconAndTextItemType {
  icon: JSX.Element;
  title: string;
}

interface Props extends Omit<HTMLColProps, "data"> {
  data: IconAndTextItemType;
}

const IconAndTextItem = ({ data, ...htmlProps }: Props) => (
  <Col {...htmlProps} className={classes.iconAndTextItem} xs={12} sm={6}>
    <div className={classNames(classes.iconAndTextItem__icon)}>{data.icon}</div>
    <p className={classes.iconAndTextItem__text}>
      <HtmlParser html={prepositions(data.title)} />
    </p>
  </Col>
);

export default IconAndTextItem;
